<template>
    <tippy-component class="overflow-hidden ml-1 cursor-pointer" interactive>
        <template #trigger>
            <div
                class="preset-thumbnail"
                :class="{
                    disabled: disabled
                }"
                @click="handleClick"
            >
                <div class="thumbnail-container">

                    <c-lazy>
                        <img
                            v-if="preset.thumbnail"
                            :src="preset.thumbnail"
                            :alt="preset.label"
                            class="thumbnail-image"
                            lazy
                        />
                        <img
                            v-else
                            :src="require('@/angular-app/images/placeholderCustomily.png')"
                            :alt="preset.label"
                            class="thumbnail-image"
                            lazy
                        />
                    </c-lazy>
                </div>

                <div class="preset-label">{{ preset.label }}</div>
            </div>
        </template>
        <body-preset-grid-thumbnail-hover :preset="preset" />
    </tippy-component>
</template>

<script setup lang="ts">
import { ImageEffectPreset } from '@/components/DesignStudio/ImageEffectsProperties/types/presets';
import BodyPresetGridThumbnailHover from '@/components/DesignStudio/ImageEffectsProperties/components/create/components/body/preset/grid/thumbnail/hover/BodyPresetGridThumbnailHover.vue';
import CLazy from '@/components/CLazy.vue';
import { TippyComponent } from 'vue-tippy';

interface Props {
    preset: ImageEffectPreset;
    isSelected?: boolean;
    disabled?: boolean;
}

interface Emits {
    (event: 'select', preset: ImageEffectPreset): void;
}

const props = withDefaults(defineProps<Props>(), {
    isSelected: false,
    disabled: false
});

const emit = defineEmits<Emits>();

const handleClick = () => {
    if (props.disabled) return;
    emit('select', props.preset);
};
</script>

<style scoped lang="scss">
.preset-thumbnail {
    position: relative;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
    gap: 6px;

    &.disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
}

.api-key-badge {
    position: absolute;
    top: 6px;
    right: 6px;
    z-index: 10;
    background: var(--gray-dark);
    color: #fff;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.tag-badge {
    position: absolute;
    left: 6px;
    bottom: 6px;
    z-index: 10;
}

.thumbnail-container {
    position: relative;
    width: 100%;
    aspect-ratio: 1;
    overflow: hidden;
    border: 1px solid var(--gray-light);
    border-radius: 8px;
    transition: all 0.3s ease;

    &:hover {
        border-color: var(--primary-purple);
    }
}

.thumbnail-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
}

.preset-label {
    font-weight: 500;
    font-size: 11px;
    color: #333;
    margin-top: 6px;
    line-height: 1.2;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
